import React from 'react';
import jeuSocieteImg from '../../static/images/section7-jouer/jeux.png';
import trais from '../../static/images/effects/diags.svg';
import jeu1 from '../../static/images/section7-jouer/1-1200.png';
import jeu2 from '../../static/images/section7-jouer/2-1200.png';
import jeu3 from '../../static/images/section7-jouer/3-1200.png';
import jeu4 from '../../static/images/section7-jouer/4-1200.png';
import jeu5 from '../../static/images/section7-jouer/5-1200.png';
import jeu6 from '../../static/images/section7-jouer/6-1200.png';

export const Section7Jouer = ({ setImgModalOpen, setImgModalSrc }) => {
  const openModal = (src) => () => {
    setImgModalOpen(true);
    setImgModalSrc(src);
  };
  return (
    <section id="section7-jouer">
      <div className="flex flex-col-reverse md:flex-row section_image">
        <div className="w-full md:w-1/2 texte-section-jeu">
          <h2>
            Jouer...
          </h2>
          <div>
            <p>
              {' '}
              Entre sauts de marelle et déconstruction des stéréotypes de genre, entre lancers de dé et discussion sur l’aide accessible aux enfants, cet atelier a donné vie à un jeu de société à la fois ludique et pédagogique. Ensemble, jouons !
              {' '}
              <br />
              <br />
              {' '}
              A vous de jouer !
            </p>
          </div>
        </div>
        <div className="bg-section-jeu">
          <img className="img-jeu" src={jeuSocieteImg} alt="jeu de société 'le Monde qui tourne'" />
          <img className="trais-jeu" src={trais} alt="trais" />
          <img className="trais2-jeu" src={trais} alt="trais" />
        </div>
      </div>

      <div className="mt-8 flex flex-col md:flex-row flex-wrap w-10/12 m-auto justify-center items-start">
        <img className="game-item w-full md:w-1/4" src={jeu1} alt="jeu de société 'le Monde qui tourne'" onClick={openModal(jeu1)} />
        <img className="game-item w-full md:w-1/4" src={jeu2} alt="jeu de société 'le Monde qui tourne'" onClick={openModal(jeu2)} />
        <img className="game-item w-full md:w-1/4" src={jeu3} alt="jeu de société 'le Monde qui tourne'" onClick={openModal(jeu3)} />
        <img className="game-item w-full md:w-1/4" src={jeu4} alt="jeu de société 'le Monde qui tourne'" onClick={openModal(jeu4)} />
        <img className="game-item w-full md:w-1/4" src={jeu5} alt="jeu de société 'le Monde qui tourne'" onClick={openModal(jeu5)} />
        <img className="game-item w-full md:w-1/4" src={jeu6} alt="jeu de société 'le Monde qui tourne'" onClick={openModal(jeu6)} />
      </div>

    </section>

  );
};
